import React, { useState, useEffect } from 'react';
import { Badge, Popover, List, Button, Empty, Tag } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';

const typeColor = {
  task: 'blue', task_done: 'green', name_suggestion: 'purple', overdue: 'red',
  iprs: 'orange', not_distributed: 'volcano', no_poster: 'magenta',
  release: 'cyan', inactive: 'red', late_arrival: 'orange', absent_today: 'red'
};

// Notification bell: polls /notifications every 60s and shows a badge + dropdown list.
export default function NotificationBell() {
  const [count, setCount] = useState(0);
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const load = async () => {
    try {
      const res = await api.get('/notifications');
      setCount(res.data?.count || 0);
      setItems(res.data?.items || []);
    } catch (err) { /* ignore */ }
  };

  useEffect(() => {
    load();
    const t = setInterval(() => { if (!document.hidden) load(); }, 20000);
    return () => clearInterval(t);
  }, []);

  const content = (
    <div style={{ width: 300 }}>
      {items.length === 0
        ? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="All clear" />
        : (
          <List
            size="small"
            dataSource={items}
            renderItem={(it) => (
              <List.Item
                style={{ cursor: it.link ? 'pointer' : 'default' }}
                onClick={() => { if (it.link) { navigate(it.link); setOpen(false); } }}
              >
                <Tag color={typeColor[it.type] || 'default'}>{it.count}</Tag>
                <span style={{ flex: 1 }}>{it.text}</span>
              </List.Item>
            )}
          />
        )}
      <div style={{ textAlign: 'center', marginTop: 8 }}>
        <Button type="link" size="small" onClick={load}>Refresh</Button>
      </div>
    </div>
  );

  return (
    <Popover content={content} title="Notifications" trigger="click" open={open} onOpenChange={setOpen} placement="bottomRight">
      <Badge count={count} size="small" offset={[-2, 2]}>
        <BellOutlined style={{ fontSize: 20, cursor: 'pointer' }} />
      </Badge>
    </Popover>
  );
}
